import { motion } from "framer-motion";
import { MapPin, MessageCircle } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/Reveal";
import { CITIES, CONTACT } from "@/data/site";

const waLink = (city) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
    `Hi AzoApp, I want to check service availability in ${city}.`
  )}`;

export default function Cities() {
  return (
    <section id="cities" className="relative py-20 sm:py-28 overflow-hidden" data-testid="cities-coverage-section">
      <div className="pointer-events-none hidden sm:block absolute top-1/3 -right-40 h-[420px] w-[420px] rounded-full bg-azo-primary/12 blur-[120px]" />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <Reveal className="flex items-center gap-2 text-azo-primary font-mono2 text-xs uppercase tracking-widest mb-4">
              <span className="h-px w-8 bg-azo-primary" /> 03 — Coverage
            </Reveal>
            <h2 className="font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
              <MaskedLines lines={["Live in 8 cities", "across Bihar."]} />
            </h2>
          </div>
          <Reveal delay={0.2} className="max-w-sm text-azo-muted text-base">
            Aapka sheher list me hai? App download karke turant book karo, ya WhatsApp par availability check karo.
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {CITIES.map((c, i) => (
            <motion.div
              key={c.name}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: (i % 4) * 0.06 }}
              data-testid={`city-card-${c.name.toLowerCase()}`}
              className="group relative rounded-2xl border border-azo-border bg-azo-surface p-5 overflow-hidden hover:border-azo-primary hover:-translate-y-1 transition-all duration-400"
            >
              <div className="flex items-center justify-between">
                <span className="grid h-10 w-10 place-items-center rounded-xl bg-azo-primary/12 text-azo-primary group-hover:bg-azo-primary group-hover:text-white transition-colors duration-400">
                  <MapPin size={18} />
                </span>
                <span className="flex items-center gap-1.5 text-[11px] text-azo-emerald font-medium">
                  <span className="h-1.5 w-1.5 rounded-full bg-azo-emerald animate-pulse" /> Live
                </span>
              </div>
              <h3 className="mt-4 font-heading font-bold text-lg sm:text-xl">{c.name}</h3>
              <p className="text-xs font-mono2 uppercase tracking-wider text-azo-muted">{c.tag}</p>
              <p className="mt-3 text-sm text-azo-text font-semibold">{c.pros} <span className="font-normal text-azo-muted">pros active</span></p>

              <a
                href={waLink(c.name)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`city-whatsapp-${c.name.toLowerCase()}`}
                className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-azo-primary hover:gap-2.5 transition-all duration-300"
              >
                <MessageCircle size={14} /> Check on WhatsApp
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
